import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import React from 'react';
import { useStyles } from '../styles';

const TicketFilters = ({
  filterOption,
  setFilterOption,
  lob,
  region,
  owner,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <div
      className={
        isExtraSmallScreen ? classes.filterContainer : classes.filterGap
      }
    >
      <FormControl fullWidth={isExtraSmallScreen}>
        <InputLabel shrink variant="outlined">
          LOB
        </InputLabel>
        <Select
          label="LOB"
          variant="outlined"
          id="lob-name"
          className={classes.filterDropdown}
          classes={{ root: classes.filterPadding }}
          onChange={(val: any) => {
            setFilterOption({
              ...filterOption,
              lob: val.target.value,
            });
          }}
          value={filterOption.lob}
        >
          {lob &&
            lob.map((t: string) => (
              <MenuItem key={`type-option-${t}`} value={t}>
                {t}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <FormControl fullWidth={isExtraSmallScreen}>
        <InputLabel shrink variant="outlined">
          Region
        </InputLabel>
        <Select
          label="Region"
          id="region-name"
          variant="outlined"
          className={classes.filterDropdown}
          value={filterOption.region}
          onChange={(val: any) => {
            setFilterOption({
              ...filterOption,
              region: val.target.value,
            });
          }}
          classes={{ root: classes.filterPadding }}
        >
          {region &&
            region.map((t: string) => (
              <MenuItem key={`type-option-${t}`} value={t}>
                {t}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <FormControl fullWidth={isExtraSmallScreen}>
        <InputLabel shrink variant="outlined">
          Owner
        </InputLabel>
        <Select
          label="Owner"
          id="owner-name"
          variant="outlined"
          className={classes.filterDropdown}
          classes={{ root: classes.filterPadding }}
          value={filterOption.owner}
          onChange={(val: any) => {
            setFilterOption({
              ...filterOption,
              owner: val.target.value,
            });
          }}
        >
          {owner !== '' &&
            owner.map((t: string) => (
              <MenuItem key={`type-option-${t}`} value={t}>
                {t}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default TicketFilters;
